export const IDEA_CHANGE_INPUT = "IDEA_CHANGE_INPUT";
export const IDEA_SUBMIT_REQUESTING = "IDEA_SUBMIT_REQUESTING";
export const IDEA_SUBMIT_SUCCESS = "IDEA_SUBMIT_SUCCESS";
export const IDEA_SUBMIT_ERROR = "IDEA_SUBMIT_ERROR";
export const IDEA_GET_SELECTION_REQUESTING = "IDEA_GET_SELECTION_REQUESTING";
export const IDEA_GET_SELECTION_SUCCESS = "IDEA_GET_SELECTION_SUCCESS";
export const IDEA_GET_SELECTION_ERROR = "IDEA_GET_SELECTION_ERROR";
export const IDEA_SELECT_REQUESTING = "IDEA_SELECT_REQUESTING";
export const IDEA_USER_GET_REQUESTING = "IDEA_USER_GET_REQUESTING";
export const IDEA_USER_GET_SUCCESS = "IDEA_USER_GET_SUCCESS";
export const IDEA_USER_GET_ERROR = "IDEA_USER_GET_ERROR";
export const IDEA_USER_SELECT = "IDEA_USER_SELECT";
export const IDEA_USER_MODIFY_REQUESTING = "IDEA_USER_MODIFY_REQUESTING";
export const IDEA_USER_MODIFY_SUCCESS = "IDEA_USER_MODIFY_SUCCESS";
export const IDEA_USER_MODIFY_ERROR = "IDEA_USER_MODIFY_ERROR";
export const IDEA_USER_DELETE_REQUESTING = "IDEA_USER_DELETE_REQUESTING";
export const IDEA_USER_DELETE_ERROR = "IDEA_USER_DELETE_ERROR";
export const IDEA_USER_DELETE_SUCCESS = "IDEA_USER_DELETE_SUCCESS";
export const IDEA_SELECTED_CHANGE_INPUT = "IDEA_SELECTED_CHANGE_INPUT";
export const IDEA_FOCUS_MENU = "IDEA_FOCUS_MENU";
export const IDEA_RATE_REQUESTING = "IDEA_RATE_REQUESTING";
export const IDEA_RATE_ERROR = "IDEA_RATE_ERROR";
export const IDEA_RATE_SUCCESS = "IDEA_RATE_SUCCESS";
export const IDEA_RATE_MODIFY = "IDEA_RATE_MODIFY";
export const IDEA_GET_ALL_REQUESTING = "IDEA_GET_ALL_REQUESTING";
export const IDEA_GET_ALL_SUCCESS = "IDEA_GET_ALL_SUCCESS";
export const IDEA_GET_ALL_ERROR = "IDEA_GET_ALL_ERROR";
export const IDEA_SEE_SELECT = "IDEA_SEE_SELECT";
export const IDEA_CHANGE_STATUS_ERROR = "IDEA_CHANGE_STATUS_ERROR";
export const IDEA_CHANGE_STATUS_SUCCESS = "IDEA_CHANGE_STATUS_SUCCESS";
export const IDEA_CHANGE_STATUS_REQUESTING = "IDEA_CHANGE_STATUS_REQUESTING";
export const IDEA_ALL_REMOVE_FILTER = "IDEA_ALL_REMOVE_FILTER";
export const IDEA_ALL_ADD_FILTER = "IDEA_ALL_ADD_FILTER";
export const IDEA_POST_COMMENT_REQUESTING = "IDEA_POST_COMMENT_REQUESTING";
export const IDEA_POST_COMMENT_SUCCESS = "IDEA_POST_COMMENT_SUCCESS";
export const IDEA_POST_COMMENT_ERROR = "IDEA_POST_COMMENT_ERROR";
export const IDEA_LOAD_ALL_REQUESTING = "IDEA_LOAD_ALL_REQUESTING";
export const IDEA_LOAD_ALL_SUCCESS = "IDEA_LOAD_ALL_SUCCESS";
export const IDEA_LOAD_ALL_ERROR = "IDEA_LOAD_ALL_ERROR";
export const IDEA_UPLOAD_PICTURE_REQUESTING = "IDEA_UPLOAD_PICTURE_REQUESTING";
export const IDEA_UPLOAD_PICTURE_SUCCESS = "IDEA_UPLOAD_PICTURE_SUCCESS";
export const IDEA_UPLOAD_PICTURE_ERROR = "IDEA_UPLOAD_PICTURE_ERROR";
export const IDEA_SELECTED_UPLOAD_PICTURE_REQUESTING =
  "IDEA_SELECTED_UPLOAD_PICTURE_REQUESTING";
export const IDEA_SELECTED_UPLOAD_PICTURE_SUCCESS =
  "IDEA_SELECTED_UPLOAD_PICTURE_SUCCESS";
export const IDEA_SELECTED_UPLOAD_PICTURE_ERROR =
  "IDEA_SELECTED_UPLOAD_PICTURE_ERROR";

export const IDEA_CHANGE = "IDEA_CHANGE";
export const IDEA_NEW = "IDEA_NEW";

export const IDEA_GET_REQUESTING = "IDEA_GET_REQUESTING";
export const IDEA_GET_ERROR = "IDEA_GET_ERROR";
